import { useAllowedFeatures } from '@/composables/app/useAllowedFeatures'

export const requireAuthenticationFormGuard = ({ to }) => {
  const { allowedAuthenticationForm } = useAllowedFeatures()

  return allowedAuthenticationForm ? true : { name: 'Login', params: to.params }
}

export const requireResetPasswordTokenGuard = ({ to }) => {
  const { query, params } = to

  return query.token ? true : { name: 'Login', params }
}